import { LitElement, html } from 'lit';

import { api } from '../api/index.js';
import { loadState, staleWarning } from '../components/load-state.js';
import { poll } from '../poll.js';
import { pageStyles } from '../../styles/shared/page.js';
import { TableLabels } from '../table-labels.js';
import { tableStyles } from '../../styles/shared/tables.js';
import { formStyles } from '../../styles/shared/forms.js';

/**
 * Operator view: the customers, with how many instances and members each has and who owns it. A
 * customer's instances and members are on its own page.
 */
class CustomersPage extends LitElement {
  static styles = [
    pageStyles,
    tableStyles,
    formStyles,
  ];

  constructor() {
    super();
    new TableLabels(this);
    this.poll = poll(this, () => api.customers());
  }

  render() {
    const head = html`
      <header class="page-head">
        <div>
          <div class="page-title">
            <h1>Customers</h1>
            <plane-help topic="customers">
              <p>A customer is who the workspaces are for. Its members see its workspaces and nothing else: not the servers, not the workspaces of other customers.</p>
              <p>An <strong>owner</strong> changes the workspaces and invites people; a <strong>member</strong> sees them and can restart them. Invite the first owner: they invite the others.</p>
            </plane-help>
          </div>
          <p class="lead">The members of a customer see its workspaces and nothing else.</p>
        </div>
        <div class="actions">
          <a class="button primary" href="/customers/new">New customer</a>
        </div>
      </header>
    `;
    const pending = loadState(this.poll, 'the customers');
    if (pending) {
      return html`${head}${pending}`;
    }
    const customers = this.poll.value;
    if (customers.length === 0) {
      return html`${head}${staleWarning(this.poll)}<p class="empty">No customer yet.</p>`;
    }
    return html`
      ${head} ${staleWarning(this.poll)}
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Customer</th>
              <th>Owners</th>
              <th class="num">Members</th>
              <th class="num">Workspaces</th>
            </tr>
          </thead>
          <tbody>
            ${customers.map((customer) => {
              const owners = customer.members.filter((member) => member.role === 'owner').map((member) => member.username);
              return html`
                <tr>
                  <td><a href="/customers/${customer.id}">${customer.name}</a></td>
                  <td>${owners.length ? owners.join(', ') : html`<span class="muted">none yet</span>`}</td>
                  <td class="num">${customer.members.length}</td>
                  <td class="num">${customer.instances.length}</td>
                </tr>
              `;
            })}
          </tbody>
        </table>
      </div>
    `;
  }
}

customElements.define('plane-customers-page', CustomersPage);
